import React from 'react';

const Loader = () => {
  return (
    <div className='container mx-auto p-4'>
      <div className='contain flex items-center justify-center text-green-500'>
        <div className='back'>
          <h1 className='text-xl md:text-3xl lg:text-6xl'>N</h1>
          <h1 className='text-xl md:text-3xl lg:text-6xl'>a</h1>
          <h1 className='text-xl md:text-3xl lg:text-6xl'>i</h1>
          <h1 className='text-xl md:text-3xl lg:text-6xl'>j</h1>
          <h1 className='text-xl md:text-3xl lg:text-6xl'>a</h1>
          <h1 className='text-xl md:text-3xl lg:text-6xl'>P</h1>
          <h1 className='text-xl md:text-3xl lg:text-6xl'>r</h1>
          <h1 className='text-xl md:text-3xl lg:text-6xl'>i</h1>
          <h1 className='text-xl md:text-3xl lg:text-6xl'>m</h1>
          <h1 className='text-xl md:text-3xl lg:text-6xl'>e</h1>
        </div>
      </div>
    </div>
  );
};

export default Loader;
